module.exports = __webpack_public_path__ + "assets/images/UNFIT5.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/UNFIT5.png
// module id = 1443
// module chunks = 1